"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var idm_currency_rate_frontend_1 = require("@synisys/idm-currency-rate-frontend");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var sis_money_settings_component_1 = require("./sis-money-settings.component");
var SisDynamicMoneyComponent = /** @class */ (function () {
    function SisDynamicMoneyComponent() {
        this.moneyChange = new core_1.EventEmitter();
    }
    Object.defineProperty(SisDynamicMoneyComponent.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            this._id = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisDynamicMoneyComponent.prototype, "isReadonly", {
        get: function () {
            return this._isReadonly;
        },
        set: function (value) {
            this._isReadonly = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisDynamicMoneyComponent.prototype, "money", {
        get: function () {
            return this._money;
        },
        set: function (value) {
            this._money = value;
            this.moneyChange.emit(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisDynamicMoneyComponent.prototype, "hint", {
        get: function () {
            return this._hint;
        },
        set: function (value) {
            this._hint = value;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], SisDynamicMoneyComponent.prototype, "moneyChange", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], SisDynamicMoneyComponent.prototype, "id", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], SisDynamicMoneyComponent.prototype, "isReadonly", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_currency_rate_frontend_1.MoneyModel),
        __metadata("design:paramtypes", [idm_currency_rate_frontend_1.MoneyModel])
    ], SisDynamicMoneyComponent.prototype, "money", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_crosscutting_concepts_frontend_1.MultilingualString),
        __metadata("design:paramtypes", [idm_crosscutting_concepts_frontend_1.MultilingualString])
    ], SisDynamicMoneyComponent.prototype, "hint", null);
    SisDynamicMoneyComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'sis-dynamic-money',
            template: "\n                 <sis-money [id]=\"id\" [(money)]=\"money\" [isReadonly]=\"isReadonly\" [hint]=\"hint\">\n                 </sis-money>\n             ",
            changeDetection: core_1.ChangeDetectionStrategy.OnPush
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            name: 'Money',
            cellCount: 3,
            settings: {
                main: sis_money_settings_component_1.SisMoneySettingsComponent,
            },
            template: "\n                            <sis-dynamic-money [id]=\"'%{id}'\" [(money)]=\"%{field}\" [isReadonly]=\"%{isReadonly}\"\n                                               [hint]=\"%{hint}\">\n                            </sis-dynamic-money>\n                     ",
            isFieldBound: true,
        })
    ], SisDynamicMoneyComponent);
    return SisDynamicMoneyComponent;
}());
exports.SisDynamicMoneyComponent = SisDynamicMoneyComponent;
var a = idm_crosscutting_concepts_frontend_1.MultilingualString; // for tsc
//# sourceMappingURL=sis-dynamic-money.component.js.map